export const GROWTH_GLOBAL_NAV = {
  VARIATION_A: 'variation_a',
  VARIATION_B: 'variation_b',
  VARIATION_C: 'variation_c',
  VARIATION_D: 'variation_d',
  VARIATION_E: 'variation_e',
};
